<div class="text-center p-4 header rounded-t-2xl">
    <h1><b> WFM CDFT Information</b></h1>
</div>
<div class="grid grid-cols-2 gap-4 items-center py-6 px-4 w-full">
    <b>Risk Ranking: </b>
    <span>
        {{ state.riskRanking ?? "-" }}
    </span>
    <b>CDFT Healthiness Result: </b>
    <span [ngClass]="{
        'healthyBadge': state.wfamStatus == wfamStatus.HEALTHY,
        'unhealthyBadge': state.wfamStatus == wfamStatus.UNHEALTHY,
    }">
        {{ state.wfamStatus ?? "-" }}
    </span>
</div>